// extracted by mini-css-extract-plugin
export default {"deleteConfirmation":"DeleteConfirmation_deleteConfirmation__JQtcF","buttons":"DeleteConfirmation_buttons__RPvGW"};